import React, {useEffect} from 'react';
import {REACT_APP_ENV} from '../../../../index';
import Width from '../../../assets/Width';
import {CREATE_ORDER_WEB} from '../../../utils/apiUrl';

const Direct24 = ({route}) => {
  const rechargeData = route?.params?.rechargeDetails;
  const token = window.localStorage.getItem('token');

  useEffect(() => {
    const param = {
      amount: rechargeData?.amount,
      currency: rechargeData?.currency,
      lang: rechargeData?.lang,
      payerData: {
        payerFirstName: rechargeData?.payerFirstName,
        payerLastName: '',
        payerEmail: rechargeData?.payerEmail,
      },
      url: rechargeData?.url
        ? rechargeData?.url
        : `${CREATE_ORDER_WEB}?Authorization=${token.replace(
            'Bearer ',
            '',
          )}&pg=direct24&couponCode=${rechargeData?.couponCode}`,
      country: rechargeData?.country,
    };
    const isProd =
      REACT_APP_ENV === 'prod' || REACT_APP_ENV === 'preprod' ? true : false;
    const script = document.createElement('script');
    const body = document.getElementsByTagName('body')[0];
    script.src = isProd
      ? 'https://connect-js.directa24.com/directa24.js'
      : 'https://connect-js-stg.directa24.com/directa24.js';
    body.appendChild(script);
    script.addEventListener('load', () => {
      let directaLib1 = directa24(
        'jtLErYragdqxiFsZWZBzXvDOrWZHKxiuLtMbscVZ',
        param,
      );
      directaLib1.init(document.getElementById('main'), 'grid');
    });
  }, []);
  return <div style={{height: Width.height}} id="main"></div>;
};

export default Direct24;
